<template>
    <div class="row data-table" :class="[baseClass, {'mb-0': tableInline}]">
        <div class="col">
            <!-- FILTERS -->
            <div class="row data-table__filters-wrapper" ref="dataFilters" v-if="filtersSlot || title">
                <div class="col">
                    <slot name="filters"
                        v-if="filtersSlot"
                        :table-filters="collection.get('filters')"
                        :search="onSearch"
                        :reset-search="onResetSearch">
                        <form autocomplete="false"
                            data-vv-scope="form"
                            @submit.prevent="onBeforeSearch">
                            <div class="row header mb-2 mb-md-0">
                                <div class="col d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center mt-2 mb-3 mt-sm-0 mb-md-4">
                                    <h1 class="content-title">{{ $t(title) }}</h1>

                                    <div class="d-flex flex-column flex-sm-row flex-grow-1 flex-sm-grow-0">
                                        <div class="d-flex flex-wrap d-sm-inline-flex flex-sm-nowrap align-items-center flex-fill flex-sm-grow-0 order-2 order-sm-1">
                                            <slot name="filters-buttons"
                                                :table-filters="collection.get('filters')"
                                                :search="onSearch"
                                                :reset-search="onResetSearch"
                                                :disabled="searchDisabled"
                                                :expanded="expandedFilters">
                                            </slot>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-between justify-content-sm-end w-100 ml-sm-auto pb-2 pb-sm-0 order-1 order-sm-2">
                                            <button
                                                v-if="btnClearFilters"
                                                v-show="expandedFilters"
                                                class="btn btn-link min-w-auto font-small text-decoration-none z-depth-0 py-sm-0 my-sm-0 m-0 pr-0 pl-0 pl-sm-3"
                                                :disabled="searchDisabled"
                                                type="button"
                                                @click.prevent="onResetSearch">
                                                {{ $t(`${titleClearFilters}`) }}
                                            </button>
                                            <button
                                                v-if="collapsibleFilters"
                                                class="btn btn-link min-w-auto font-small text-decoration-none z-depth-0 m-0"
                                                :class="[expandedFilters ? 'p-0' : 'pr-0']"
                                                :disabled="searchDisabled"
                                                type="button"
                                                data-toggle=""
                                                data-target="#filters"
                                                :aria-expanded="expandedFilters"
                                                aria-controls="filter"
                                                @click.prevent="expandedFilters = !expandedFilters;">
                                                <div class="d-flex align-items-center flex-nowrap">
                                                    <span class="pr-2">{{ expandedFilters ? btnCollapseFilters.toogle.expanded : btnCollapseFilters.toogle.collapsed }}</span>
                                                    <i class="fas" :class="[expandedFilters ? 'fa-minus-square' : 'fa-plus-square']"></i>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <collapse-transition>
                                <div v-show="expandedFilters" id="filters">
                                    <div class="row">
                                        <div class="col-12">
                                            <slot name="filters-body"
                                                :table-filters="collection.get('filters')"
                                                :search="onSearch"
                                                :reset-search="onResetSearch">
                                            </slot>
                                        </div>
                                    </div>

                                    <div class="row" v-if="btnSearchFilters">
                                        <div class="col-12 col-sm-auto mx-auto mr-sm-auto ml-sm-0">
                                            <div class="row mt-0 mb-4 mt-sm-2 mb-sm-4">
                                                <div class="col col-sm-auto ">
                                                    <button
                                                        :disabled="searchDisabled"
                                                        type="submit"
                                                        class="btn btn-main btn-rounded btn-sm btn-block btn-responsive">
                                                        {{ $t(`${titleSearchFilters}`) }}
                                                    </button>
                                                </div>
                                                <slot name="search-buttons"
                                                    :table-filters="collection.get('filters')"
                                                    :search="onSearch"
                                                    :reset-search="onResetSearch"
                                                    :disabled="searchDisabled">
                                                </slot>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </collapse-transition>
                        </form>
                    </slot>
                    <div v-else-if="title"
                        class="row header mb-2 mb-md-0">
                        <div class="col d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                            <div class="title mb-2 mb-md-0 mb-md-4">{{ $t(title) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BEFORE DATA -->
            <slot name="beforeTable" :table-filters="collection.get('filters')"></slot>

             <!-- DATA  -->
            <div class="row data-table__table-wrapper">
                <div class="col">
                    <slot name="title" :add="onAddItem">
                        <div class="row data-table__table-header" v-if="hasTitleData || hasButtonsHeaderSlot || canExportData || canClearFeatures">
                            <div class="col-12 d-flex align-items-center mb-3">
                                <span class="subtitle" v-if="hasTitleData">
                                    {{ $t(titleData) }}
                                </span>
                                <div v-if="canExportData"
                                    class="export-header d-flex flex-row align-items-center justify-content-center">
                                    <template v-if="exportFormats.length == 1">
                                        <button
                                            type="button"
                                            :key="`format-${exportFormats[0].format}`"
                                            :disabled="searchDisabled"
                                            :title="$t(`${exportFormats[0].title ? exportFormats[0].title : exportFormats[0].name}`)"
                                            @click.prevent="(evt) => onExport(exportFormats[0], evt)"
                                            class="btn btn-link min-w-auto btn-lg p-0 z-depth-0"
                                            data-toggle="tooltip-city"
                                            data-dismiss="modal"
                                            aria-label="Format">
                                            <span class="">
                                                <!-- <i :class="exportFormats[0].icon ? exportFormats[0].icon : 'fas fa-file'"></i> -->
                                                <i class="fas fa-download"></i>
                                            </span>
                                        </button>
                                    </template>
                                    <template v-else>
                                        <div class="btn-group">
                                            <button
                                                class="btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0 btn-sm dropdown-toggle"
                                                type="button"
                                                :title="$t(titleExportData)"
                                                :disabled="searchDisabled"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                                <span class="text-secondary-color">
                                                    <i class="fas fa-download"></i>
                                                </span>
                                            </button>
                                            <div class="dropdown-menu">
                                                <button
                                                    v-for="(cfgFormat, idx) in exportFormats"
                                                    :key="`format-${cfgFormat.format}-${idx}`"
                                                    :disabled="searchDisabled"
                                                    type="button"
                                                    @click.prevent="(evt) => onExport(cfgFormat, evt)"
                                                    class="dropdown-item btn btn-link min-w-auto m-0 btn-lg py-0 px-2 z-depth-0"
                                                    data-dismiss="modal"
                                                    aria-label="Format">
                                                    <span class="icon text-secondary-color">
                                                        <template v-if="cfgFormat.img">
                                                            <img class="export" :src="getImgUrl(cfgFormat.img)">
                                                        </template>
                                                        <template v-else>
                                                            <i :class="['export', cfgFormat.icon ? cfgFormat.icon : 'fas fa-file']"></i>
                                                        </template>
                                                    </span>
                                                    <span>
                                                        {{ $t(cfgFormat.name) }}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <button
                                        v-for="(cfgFormat, idx) in exportTypedFormats"
                                        :key="`format-typed-${idx}`"
                                        :title="$t(cfgFormat.title ? cfgFormat.title : cfgFormat.name)"
                                        data-toggle="tooltip-city"
                                        :disabled="searchDisabled"
                                        class="btn btn-link min-w-auto text-decoration-none p-0 z-depth-0"
                                        type="button"
                                        @click.prevent="onExport(cfgFormat)">
                                        <template v-if="cfgFormat.img">
                                            <img class="export" :src="getImgUrl(cfgFormat.img)">
                                        </template>
                                        <template v-else-if="cfgFormat.icon">
                                            <i :class="['export', cfgFormat.icon]"></i>
                                        </template>
                                    </button>
                                </div>
                                <slot name="buttons-header" :queryParams="queryParams()" :total="totalRowCount" :disabled="searchDisabled" />

                                <div v-if="canClearFeatures"
                                    class="d-flex flex-row align-items-center justify-content-center">
                                    <button
                                        :title="$t(titleClearFeatures)"
                                        data-toggle="tooltip-city"
                                        :disabled="searchDisabled"
                                        class="btn btn-link min-w-auto text-decoration-none p-0 z-depth-0"
                                        type="button"
                                        @click.prevent="onClearFeatures">
                                        <i :class="classClearFeatures"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </slot>
                    <div
                        v-if="selectedRowCount && !disableSelectInfo"
                        class="vgt-selection-info-row clearfix"
                        :class="selectionInfoClass"
                    >
                        {{selectionInfo}}
                        <a
                            href=""
                            @click.prevent="unselectAllInternal(true)"
                        >
                            {{clearSelectionText}}
                        </a>
                        <div class="vgt-selection-info-row__actions vgt-pull-right">
                            <slot name="selected-row-actions">
                            </slot>
                        </div>
                    </div>
                    <div class="" :class="[{'city-table-wrapper': !tableInline}, tableWrapperClass]">
                        <table class="table" :class="[fullTableClass, {'loading': isLoading()}]">
                            <thead>
                                <tr :class="rowHeaderClass">
                                    <th v-if="selectable" class="checkbox-col">
                                        <div class="form-check city-form-check pl-0">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                id="th-checkbox"
                                                :checked="allSelected"
                                                :indeterminate.prop="allSelectedIndeterminate"
                                                @change="toggleSelectAll"
                                                />
                                                <label class="form-check-label" for="th-checkbox"></label>
                                        </div>
                                    </th>
                                    <th scope="col"
                                        class="text-nowrap"
                                        :class="column.class || ''"
                                        v-for="(column, index) in activeColumns"
                                        :key="`${cpName}th-${index}`">
                                        <a
                                            v-if="column.sortable"
                                            @click.prevent="collection.toggleSortable(column.field)"
                                            :class="{ '' : collection.isOrderedBy(column.field)}"
                                            data-toggle="tooltip-city"
                                            :title="titleSortable($t(column.label_tooltip || column.label))"
                                        >
                                            <span>
                                                {{ $t(column.label) }}
                                                <i v-if="collection.isOrderedBy(column.field)" class="pl-1 fas" :class="sortIcon"></i>
                                            </span>
                                        </a>
                                        <span v-else>
                                            {{ $t(column.label) }}
                                        </span>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <template v-if="hasResult">
                                    <template v-for="(row, index) in collection.items">
                                        <tr
                                            :key="`${cpName}row-${row.id || ('index-'+ index)}`"
                                            @click="onRowClicked(row, index, $event)"
                                            :class="rowBodyClass"
                                        >
                                            <td
                                                v-if="selectable"
                                                @click.stop="onCheckboxClicked(row, index, $event)"
                                                class="checkbox-col"
                                            >
                                                <div class="form-check city-form-check pl-0">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        :checked="row.vgtSelected || selRows.indexOf(row.id)>-1"
                                                        />
                                                    <label class="form-check-label"></label>
                                                </div>
                                            </td>
                                            <slot name="body"
                                                :fieldColumns="fieldColumns"
                                                :actionColumns="actionColumns"
                                                :columns="columns"
                                                :row="row"
                                                :index="index"
                                                :remove="onRemove"
                                                :add="onAddItem"
                                                :search="onSearch"
                                                :resetSearch="onResetSearch"
                                                :hasChild="hasChildConfiguration && hasRowChildValue(row, childProperty)"
                                                :childId="idRowChild(row, index)">
                                            </slot>
                                        </tr>

                                        <template v-if="hasChildConfiguration && hasRowChildValue(row, childProperty)">
                                            <tr :id="idRowChild(row, index)"
                                                :key="`${cpName}row-group-${row.id || ('index-'+ index)}`"
                                                class="collapse">
                                                <td :colspan="columns.length">
                                                    <table class="table table-child" :class="childTableClass" data-detail-view="">
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    scope="col"
                                                                    class="text-nowrap"
                                                                    v-for="(column, index) in activeChildColumns"
                                                                    :class="column.class || ''"
                                                                    :key="`${cpName}row-th-${index}`">
                                                                    <span>
                                                                        {{ isFunction(column.label) ? column.label(row) : $t(column.label) }}
                                                                    </span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(rowChild, keyChild, rowChildIndex) in row[childProperty]"
                                                                :key="`${cpName}row-group-child-${index}-${rowChild.id || rowChildIndex}`">
                                                                <slot name="row-child"
                                                                    :rowParent="row"
                                                                    :indexParent="index"
                                                                    :columns="activeChildColumns"
                                                                    :row="rowChild"
                                                                    :property="keyChild"
                                                                    :index="rowChildIndex ?? keyChild"
                                                                    :rowId="idRowChild(row, index)">
                                                                </slot>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                <tr v-else>
                                    <td :colspan="columns.length" class="text-center">
                                        <template v-if="isLoading()">
                                            <template v-if="showSpinner">
                                                <div  class="d-flex justify-content-center align-items-center">
                                                    <div class="spinner-border spinner-border-sm" role="status"></div>
                                                    <span class="pl-2">{{ $t(loadingMsg) }}</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                {{ $t(loadingMsg) }}
                                            </template>
                                        </template>
                                        <div class="" v-else>
                                            {{ $t(noDataText) }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- PAGINATION -->
            <div class="row data-table__pagination-wrapper" v-if="showPagination">
                <div class="col">
                    <pagination
                        :collection.sync="collection"
                        :loading="isLoading()"
                        :show-pagination-info="pagination.showPaginationInfo"
                        :show-per-page="pagination.showPerPage"
                        :pagination-info-class="pagination.paginationInfoClass"
                        :pagination-component-class="pagination.paginationComponentClass"
                        :pagination-info-per-page-class="pagination.paginationInfoPerPageClass"
                        :pagination-info-template="pagination.paginationInfoTemplate"
                        :pagination-info-no-data-template="pagination.paginationNoDataInfoTemplate"
                        :pagination-info-prefix-per-page-template="pagination.paginationInfoPrefixPerPageTemplate"
                        :pagination-info-suffix-per-page-template="pagination.paginationInfoSuffixPerPageTemplate"
                    ></pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HasLoadingState, HasCollection, UrlFilters} from './mixins/index';
    import merge from 'lodash-es/merge';
    import isEqual from 'lodash-es/isEqual';
    import GlobalMixin from '@/app/shared/mixins/global';
    import {formatString, isNullOrUndefined, isArray, isObject, isEmptyObject, isFunction} from '@config/utils'

    const defaultSettings = {
        order_by:'name',
        sort:'asc',
        current_page: 1,
        per_page: 10,
        per_page_options: [10, 25, 50, 100],
        queryParams: {
            current_page: 'page',
            per_page: 'per_page',
            order_by: 'sort',
            sort: 'dir',
            filters: 'filter',
        },
    };

    export default {
        name: 'data-table',
        mixins: [
            HasLoadingState,
            HasCollection,
            UrlFilters,
            GlobalMixin
        ],
        components: {
            Pagination: () => import(/* webpackChunkName: "pagination" */ './Pagination'),
            CollapseTransition: () => import(/* webpackChunkName: "collapse-transition" */ '@/app/shared/components/common/CollapseTransition'),
        },
        props: {
            title: {
                type: String,
                default: ''
            },
            route: {
                type: String,
                required: false,
                default: null
            },
            data: {
                type: Array,
                default: () => ([]),
            },
            startLoad: {
                type: Boolean,
                default: true
            },
            extraQueryParams: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            columns: {
                type: Array,
                required: true,
                default: () => ([]),
            },
            showTitleData: {
                type: Boolean,
                default: true,
            },
            titleData: {
                type: String,
                default: 'global.table.data',
            },
            collapsibleFilters: {
                type: Boolean,
                default: true
            },
            titleCollapseFilters: {
                type: String,
                default: 'global.table.filters.buttons.collapse',
            },
            titleCollapsedFilters: {
                type: String,
                default: 'global.table.filters.buttons.collapsed',
            },
            expandFilters: {
                type: Boolean,
                default: true
            },
            btnSearchFilters: {
                type: Boolean,
                default: true
            },
            titleSearchFilters: {
                type: String,
                default: 'global.table.filters.buttons.search',
            },
            btnClearFilters: {
                type: Boolean,
                default: true
            },
            titleClearFilters: {
                type: String,
                default: 'global.table.filters.buttons.clear',
            },
            btnClearFeatures: {
                type: Boolean,
                default: false
            },
            titleClearFeatures: {
                type: String,
                default: 'global.table.filters.buttons.clear_features',
            },
            classClearFeatures: {
                type: String,
                default: 'fa-regular fa-trash-can text-warning',
            },
            externalFilters: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            inlineFilters: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            autoUpdateFilter: {
                type: Boolean,
                default: false
            },
            autoUpdateExternalFilter: {
                type: Boolean,
                default: false
            },
            addParamsToUrl: {
                type: Boolean,
                default: false,
            },
            addParamsToLocalStorage: {
                type: Boolean,
                default: false
            },
            settings: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            loadingMsg: {
                type: String,
                default: 'global.table.loading',
            },
            noDataMsg: {
                type: String,
                default: 'global.table.no-data',
            },
            orderByTemplate: {
                type: String,
                default: 'global.table.order-by-template',
            },
            showPagination: {
                type: Boolean,
                default: true,
            },
            tableInline: {
                type: Boolean,
                default: false,
            },
            tableClass: {
                type: String,
                default: ''
            },
            tableWrapperClass: {
                type: String,
                default: ''
            },
            baseClass: {
                type: String,
                default: 'mb-3'
            },
            autoScroll: {
                type: Boolean,
                default: true
            },
            scrollTarget: {
                type: String,
                default: '.data-table'
            },
            allowExportData: {
                type: Boolean,
                default: false
            },
            defaultFormatExportData: {
                type: String,
                default: 'xls',
            },
            formatsExportData: {
                type: Array,
                default: () => ([]),
            },
            titleExportData: {
                type: String,
                default: 'global.table.export-data'
            },
            confirmExportData: {
                type: Boolean,
                default: true,
            },
            confirmMsgExportData: {
                type: String,
                default: 'global.table.export-data-confirm'
            },
            errorMsgExportData: {
                type: String,
                default: 'global.table.export-data-error'
            },
            newWindowExportData: {
                type: Boolean,
                default: true
            },
            funcExportData: {
                type: Function,
                default: null,
            },
            rowHeaderClass: {
                type: String,
                default: ''
            },
            rowBodyClass: {
                type: String,
                default: ''
            },
            selectOptions: {
              default() {
                return {
                  enabled: false,
                  selectionInfoClass: '',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
                  disableSelectInfo: false,
                  selectAllByGroup: false,
                };
              },
            },
            isRecursive: {
                type: Boolean,
                default: false
            },
            child: {
                default() {
                    return {
                        property: null,
                        columns: [],
                    };
                },
            },
            childTableClass: {
                type: String,
                default: ''
            },
            addUniqueKey: {
                type: Boolean,
                default: false
            },
            dateFormat: {
                type: String,
                default: null, //'YYYY-MM-DD HH:mm:ss',
            },
            searchOnEnter: {
                type: Boolean,
                default: false
            },
            showSpinner: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            timerSearchDelay: {
                type: Number,
                default: 900
            }
        },
        data(){
            return {
                loaded: false,
                expandedFilters: this.expandFilters,
                tableProps: {
                    search: '',
                    filters: {},
                },
                pagination: {
                    showPaginationInfo: true,
                    paginationInfoTemplate: '{total} Resultados encontrados',
                    paginationNoDataInfoTemplate: '{total} Resultados encontrados',
                    paginationInfoClass: "col-auto col-md text-left order-0",
                    paginationComponentClass: "col-sm-12 col-md my-0 order-2 order-sm-1",
                    showPerPage: true,
                    paginationInfoPerPageClass: "col-auto col-md order-1 order-sm-2 ml-auto",
                    paginationInfoPrefixPerPageTemplate: 'página {current_page} de {last_page}',
                    paginationInfoSuffixPerPageTemplate: 'por página',
                },
                previousQueryParams: {},
                timerSearch: null,

                // internal select options
                selectable: false,
                selectOnCheckboxOnly: false,
                selectAllByPage: true,
                disableSelectInfo: false,
                selectionInfoClass: '',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                selRows: [],
            }
        },
        async mounted() {
            if(this.startLoad){
                this.initialLoad();
            }
            this.setKeyEnterListener();
        },
        async beforeDestroy() {
            this.setKeyEnterListener(false);
        },
        computed: {
            hasTitleData() {
                return this.showTitleData && !!this.titleData;
            },
            fieldColumns() {
                return this.columns.filter(c => c.field || c.field_label);
            },
            actionColumns() {
                return this.columns.filter(c => !(c.field || c.field_label));
            },
            btnCollapseFilters() {
                return {
                    name: this.$t(this.titleCollapseFilters),
                    active: true,
                    toogle: {
                        expanded: '',
                        collapsed: this.$t(this.titleCollapsedFilters),
                    }
                };
            },
            cpName() {
                return this.addUniqueKey ? `${this._uid}-` : '';
            },
            noDataText() {
                return this.$t(this.noDataMsg || this.notFoundMsg);
            },
            filtersSlot() {
                if (this.$scopedSlots) {
                    return this.$scopedSlots.filters || this.$scopedSlots['filters-body'];
                }
                return null;
            },
            sortIcon() {
                return {
                    'fa-caret-up' : this.collection.isSorted('asc'),
                    'fa-caret-down' : this.collection.isSorted('desc'),
                }
            },
            fullTableClass() {
                return this.classList(this.tableClass);
            },
            externalFiltersParam() {
                let queryParams = this.collection.get('queryParams');
                let params = {}
                params[queryParams.filters] = this.externalFilters;
                return params;
            },
            allSelected() {
                return (
                    this.selectedRowCount > 0 &&
                    ((this.selectAllByPage &&
                        this.selectedPageRowsCount === this.totalPageRowCount) ||
                            (!this.selectAllByPage &&
                                this.selectedRowCount === this.totalRowCount))
                );
            },
            allSelectedIndeterminate() {
                return (
                    !this.allSelected &&
                    ((this.selectAllByPage && this.selectedPageRowsCount > 0) ||
                        (!this.selectAllByPage && this.selectedRowCount > 0))
                );
            },
            selectionInfo() {
              return `${this.selectedRowCount} ${this.selectionText}`;
            },
            selectedRowCount() {
                return this.selectedRows.length;
            },
            selectedPageRowsCount() {
                return this.selectedPageRows.length;
            },
            selectedPageRows() {
                let selectedRows = [];
                this.processedRows.forEach((row) => {
                    if (row.vgtSelected || this.selRows.indexOf(row.id)>-1) {
                        selectedRows.push(row);
                    }
                });
                return selectedRows.sort((r1, r2) => r1.id - r2.id);
            },
            selectedRows() {
                return this.selRows;
            },
            totalRowCount() {
                return this.collection.total;
            },
            totalPageRowCount() {
                return this.collection.items.length;
            },
            processedRows() {
                let computedRows = this.collection.items;
                return computedRows;
            },
            hasResult() {
                return this.collection.hasItems;
            },
            hasChildConfiguration() {
                return this.child && this.child.property;
            },
            childProperty() {
                return this.hasChildConfiguration ? this.child.property : null;
            },
            actions() {
                return this.collection.actions;
            },
            hasTitleSlot() {
                return !!this.$slots[ 'title' ] || !!this.$scopedSlots[ 'title' ];
            },
            hasButtonsHeaderSlot() {
                return !!this.$slots[ 'buttons-header' ] || !!this.$scopedSlots[ 'buttons-header' ];
            },
            activeColumns() {
                return this.columns.filter(c => !c.disabled);
            },
            activeChildColumns() {
                return this.child?.columns ? this.child.columns.filter(c => !c.disabled) : [];
            },
            searchDisabled() {
                return this.disabled || (this.isLoading());
            },
            canClearFeatures() {
                return this.btnClearFeatures && this.hasResult;
            },
            canExportData() {
                return this.allowExportData && this.hasResult;
            },
            defaultFormatExport() {
                return {
                    title: this.titleExportData,
                    name: this.defaultFormatExportData,
                    format: this.defaultFormatExportData,
                    icon: 'fas fa-download', //this.assetsPathTheme('/icons/download.svg')
                };
            },
            validFormats() {
                let formats = this.formatsExportData;
                return this.canExportData ?
                    formats.filter(item => item.acl ? this.$auth.check(item.acl) : true)
                    .filter(item => !!item.status)
                    : [];
            },
            exportFormats() {
                let formats = this.validFormats.length ? this.validFormats : [this.defaultFormatExport];
                return formats.filter(f => !!!f.type);
            },
            exportTypedFormats() {
                let formats = this.validFormats.length ? this.validFormats : [];
                return formats.filter(f => !!f.type);
            }
        },
        methods: {
            initialLoad() {
                this.reset(false, false);
                if (this.addParamsToUrl) {
                    this.checkParameters(this.tableProps.queryParams, this.$route.query);
                }
                this.collection.setState(this.tableProps);
                this.loadData().then(() => {
                    this.emitSearchEvent()
                });
            },
            setFilters(applyState=true, reset=false) {
                this.tableProps.autoUpdateFilter = this.autoUpdateFilter;
                this.tableProps.autoUpdateExternalFilter = this.autoUpdateExternalFilter;
                this.tableProps.filters = Object.assign({}, this.inlineFilters);
                if(reset) {
                    let setAll = (obj, val) => Object.keys(obj).forEach(k => {
                        if(obj[k] && typeof obj[k] == "object" ){
                            setAll(obj[k], val);
                        }else{
                            obj[k] = val;
                        }
                    });
                    let setNull = obj => setAll(obj, null);
                    setNull(this.tableProps.filters);
                }
                if(applyState){
                    this.collection.setState(this.tableProps);
                }
            },
            emitSearchEvent() {
                this.$emit('search', {actions: this.actions});
            },
            classList(...classes) {
                return classes
                    .map(c => isArray(c) ? c : [c])
                    .reduce((classes, c) => classes.concat(c), []);
            },
            titleSortable(label) {
                return this.$t(this.orderByTemplate).replace('{field}', this.$t(label));
            },
            getAllQueryParams() {
                let params = merge(
                    {},
                    this.$route.query,
                    this.extraQueryParams,
                    this.collection.allUrlParams,
                    this.externalFiltersParam
                );
                if(this.dateFormat) {
                    let queryParams = this.collection.get('queryParams');
                    let filters = params[queryParams.filters];
                    if(typeof filters === 'object') {
                        Object.keys(filters).forEach(key => {
                            let val = filters[key];
                            if(typeof val === 'object') {
                                if(val.startDate) {
                                    val.startDate = moment(val.startDate).format(this.dateFormat);
                                }
                                if(val.endDate) {
                                    val.endDate = moment(val.endDate).format(this.dateFormat);
                                }
                            }else if(val instanceof Date) {
                                val = moment(val).format(this.dateFormat);
                            }
                        });
                    }
                }
                return Object.assign({}, params);
            },
            queryParams() {
                return {
                    params: this.getAllQueryParams(),
                }
            },
            getPreviousQueryParams(key=null) {
                if(key){
                    if(this.previousQueryParams[key]){
                        let params = {};
                        params[key] = this.previousQueryParams[key];
                        return params;
                    }
                    return null;
                }else{
                    return this.previousQueryParams;
                }
            },
            async loadData() {
                if(this.route){
                    return await this.request();
                }else{
                    // this.collection.set('data', this.data);
                    return await new Promise((resolve) => {
                        this.collection.setState({'data': this.data});
                        resolve();
                    });
                }
            },
            async request() {
                if(this.isLoading()) return
                this.loading(true);

                let options = this.queryParams();
                await this.$http.get(this.route, options)
                .then(({data}) => {
                    this.collection.setState(data);
                    if (this.addParamsToUrl) {
                        this.updateParameters(options.params);
                    }
                    this.previousQueryParams = Object.assign({}, options.params);
                })
                .then(() => {
                    this.$nextTick(() => {
                        this.activeTooltip();
                    });
                })
                .finally(() => {
                    this.loading(false)
                    if(this.autoScroll && this.loaded){
                        this.scrollToTop();
                    }
                    this.loaded = true;
                })
                .catch((error) => {
                    this.$emit('error-load', error);
                    this.showError(error);
                })
            },
            async refresh() {
                await this.request();
            },
            setKeyEnterListener(register = true){
                if(this.searchOnEnter && this.filtersSlot && this.btnSearchFilters) {
                    if(register) {
                        document.addEventListener('keydown', this.onKeyEnter);
                    }else{
                        document.removeEventListener('keydown', this.onKeyEnter)
                    }
                }
            },
            onKeyEnter(event){
                if(this.expandedFilters && !this.searchDisabled) {
                    if (event.key === 'Enter') {
                        this.onBeforeSearch(true);
                    }
                }
            },
            async onBeforeSearch(resetPagination = true){
                await this.$validator
                .validateAll('form')
                .then(result => {
                    if(!result){
                        this.showError('Por favor corrija os erros no formulário');
                        return;
                    }
                    return this.onSearch(resetPagination);
                });
            },
            async onSearch(resetPagination = true) {
                if (this.timerSearch) {
                    clearTimeout(this.timerSearch);
                    this.timerSearch = null;
                }
                this.timerSearch = setTimeout(() => {
                    this.loaded = false;
                    if(resetPagination){
                        this.collection.page(1);
                    }
                    this.loadData().then(() => {
                        this.emitSearchEvent()
                    });
                }, this.timerSearchDelay); // delay
            },
            async onResetSearch() {
                this.reset();
                this.collection.page(1);
                // this.loadData();
                // this.collection.setState({
                //     current_page: 1
                // });
                this.loadData()
                .then(() => {
                    this.$emit('reset-search');
                });
            },
            onExport(params) {
                if(this.confirmExportData){
                    this.$root.$emit('openConfirmation', {
                        id: null,
                        data: null,
                        text: this.$t(this.confirmMsgExportData),
                        callback: () => {
                            this.exportData(params);
                        }
                    });
                }else{
                    this.exportData(params);
                }
            },
            exportData(params) {
                let {format, type} = params;
                let options = this.queryParams();
                if(options.params){
                    options.params['export'] = 1;
                    if(format){
                        options.params['format'] = format;
                    }
                }
                if(this.funcExportData && typeof this.funcExportData === 'function'){
                    this.funcExportData(this.totalRowCount, options, params);
                }else{
                    if(this.route){
                        this.$http.get(formatString(this.route, {format, type}), options)
                        .then(({data}) => {
                            if(data.data){
                                if(this.newWindowExportData){
                                    window.open(data.data, '_blank');
                                }
                                this.$emit('exported-data', data);
                            }else{
                                this.showError({message: this.errorMsgExportData, title: this.title})
                            }
                        })
                        .finally(() => {

                        })
                        .catch((error) => {
                            this.showError(error);
                            this.$emit('exported-error-load', error);
                        })
                    }else{
                        this.$emit('export');
                    }
                }
            },
            onRemove(id, index){
                if(id) {
                    this.collection.remove({'id': id})
                }else if(!isNullOrUndefined(index)) {
                    this.collection.removeIndex(index)
                }
            },
            onClearFeatures() {
                if(this.canClearFeatures) {
                    this.$emit('clearFeatures');
                }
            },
            reset(applyState=true, resetFilters=true) {
                Object.assign(this.$data.tableProps, this.$options.data().tableProps);
                merge(this.tableProps, defaultSettings, this.settings);
                // let setAll = (obj, val) => Object.keys(obj).forEach(k => {
                //     if(obj[k] && typeof obj[k] == "object" ){
                //         setAll(obj[k], val);
                //     }else{
                //         obj[k] = val;
                //     }
                // });
                // let setNull = obj => setAll(obj, null);
                // setNull(this.inlineFilters);
                this.loaded = false;
                this.setFilters(applyState, resetFilters);
                // if(applyState){
                //     this.collection.setState(this.tableProps);
                // }
            },
            getItem(idx) {
                return this.collection.item(idx);
            },
            onAddItem(item, idx=null){
                this.addItem(item, idx);
            },
            addItem(item, idx=null) {
                return this.collection.add(item, idx);
            },
            prependItem(item) {
                return this.collection.prepend(item);
            },
            scrollToTop() {
                if(this.scrollTarget){
                    // let el = document.querySelector('.data-table');
                    // el.getBoundingClientRect().top
                    let top = 0;
                    if($(this.$refs.dataFilters))
                        top = $(this.$refs.dataFilters).outerHeight();
                    $(this.scrollTarget).animate({ scrollTop: top }, 'slow');
                }
            },
            showError: function(error) {
                this.$root.$helper.error.httpError(error);
            },
            initializeSelect() {
                const {
                    enabled,
                    selectionInfoClass,
                    selectionText,
                    clearSelectionText,
                    selectOnCheckboxOnly,
                    selectAllByPage,
                    disableSelectInfo,
                    selectAllByGroup,
                } = this.selectOptions;

                if (typeof enabled === 'boolean') {
                    this.selectable = enabled;
                }

                if (typeof selectOnCheckboxOnly === 'boolean') {
                    this.selectOnCheckboxOnly = selectOnCheckboxOnly;
                }

                if (typeof selectAllByPage === 'boolean') {
                    this.selectAllByPage = selectAllByPage;
                }

                if (typeof selectAllByGroup === 'boolean') {
                    this.selectAllByGroup = selectAllByGroup;
                }

                if (typeof disableSelectInfo === 'boolean') {
                    this.disableSelectInfo = disableSelectInfo;
                }

                if (typeof selectionInfoClass === 'string') {
                    this.selectionInfoClass = selectionInfoClass;
                }

                if (typeof selectionText === 'string') {
                    this.selectionText = selectionText;
                }

                if (typeof clearSelectionText === 'string') {
                    this.clearSelectionText = clearSelectionText;
                }
            },
            // checkbox click should always do the following
            onCheckboxClicked(row, index, event) {
                this.$set(row, 'vgtSelected', !row.vgtSelected);
                this.updateSelectedRows(row);
                this.$emit('on-row-click', {
                    row,
                    pageIndex: index,
                    selected: !!row.vgtSelected,
                    event,
                });
            },
            onRowClicked(row, index, event) {
                if (this.selectable && !this.selectOnCheckboxOnly) {
                    this.$set(row, 'vgtSelected', !row.vgtSelected);
                    this.updateSelectedRows(row);
                }
                this.$emit('on-row-click', {
                    row,
                    pageIndex: index,
                    selected: !!row.vgtSelected,
                    event,
                });
            },
            updateSelectedRows(row) {
                const key = row.id;
                const status = !!row.vgtSelected;
                const index = this.selRows.indexOf(key);
                if(status){
                    if (index == -1) {
                        this.selRows.push(key);
                    }
                }else{
                    if (index > -1) {
                        this.selRows.splice(index, 1);
                    }
                }
            },
            emitSelectedRows() {
                this.$emit('on-select-all', {
                    selected: this.selectedRowCount === this.totalRowCount,
                    selectedRows: this.selectedRows,
                });
            },
            unselectAllInternal(forceAll) {
                const rows = this.selectAllByPage && !forceAll ? this.collection.items : this.collection.items;
                rows.forEach((row, i) => {
                    this.$set(row, 'vgtSelected', false);
                    this.updateSelectedRows(row);
                });
                if(forceAll){
                    this.selRows = [];
                }
                this.emitSelectedRows();
            },
            toggleSelectAll() {
                if (this.allSelected) {
                    this.unselectAllInternal();
                    return;
                }
                const rows = this.selectAllByPage ? this.collection.items : this.collection.items;
                rows.forEach((row) => {
                    this.$set(row, 'vgtSelected', true);
                    this.updateSelectedRows(row);
                });
                this.emitSelectedRows();
            },
            idRowChild(row, index) {
                return `row-child-${row.id || index}`;
            },
            hasRowChildValue(row, property) {
                return  property in row
                    && (
                        (isArray(row[property]) && row[property].length>0) ||
                        (isObject(row[property]) && !isEmptyObject(row[property]))
                    );
            },
            getImgUrl(urlString) {
                return (urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0) ? urlString : this.assetsPathTheme(urlString);
            },
            isFunction(a) {
                return isFunction(a);
            }
        },
        watch:{
            startLoad(value) {
                if(value && !this.loaded){
                    this.initialLoad();
                }
            },
            inlineFilters: {
                immediate: true,
                deep: true,
                handler: function(value, oldValue) {
                    this.setFilters();
                }
            },
            'collection.urlParams': {
                handler(value, oldValue){
                    if(!this.loaded){
                        return;
                    }
                    if(!isEqual(value, oldValue)){
                        this.loadData().then(() => {
                            this.emitSearchEvent()
                        });
                    }
                },
                deep: true,
            },
            'collection.filters': {
                handler(value, oldValue){
                    if(!this.loaded){
                        return;
                    }
                    if(this.autoUpdateFilter && !isEqual(value, oldValue)){
                        this.onSearch();
                    }
                },
                deep: true,
            },
            'externalFilters': {
                handler(value, oldValue){
                    if(this.autoUpdateExternalFilter && !isEqual(value, oldValue)){
                        this.onSearch();
                    }
                },
                deep: true,
            },
            'data': {
                handler(value, oldValue){
                    this.collection.set('data', this.data);
                },
                deep: true,
            },
            selectOptions: {
                handler() {
                    this.initializeSelect();
                },
                deep: true,
                immediate: true,
            },
            selectedRows(newValue, oldValue) {
                this.$emit('on-selected-rows-change', {
                    selectedRows: this.selectedRows,
                });
            },
            canClearFeatures(newValue, oldValue) {
                if(newValue){
                    this.$nextTick(() => {
                        this.activeTooltip();
                    });
                }
            },
        },
    }

</script>

<style lang="scss" scoped>
    .data-table__table-header {
        .dropdown-menu {
            .dropdown-item {
                display: flex;
                flex-wrap: nowrap;
                span {
                    white-space: nowrap;
                }
                .icon {
                    margin-right: 0.25rem;
                }
            }
        }

        .btn-group,
        .btn {
            font-size: 1rem;
            margin: 0 0 0 10px;
        }
    }
</style>
